import find from 'lodash/find';
import set from 'lodash/set';
import get from 'lodash/get';

import WhitelabelConfig from './models';
import { validator } from '../_whitelabel-validator';

export const state = {
  domains: null,
  currentDomain: {
    config: new WhitelabelConfig(),
  },
  logoImage: null,
  bannerImage: null,
  faviconImage: null,
};

export const mutations = {
  initializeNewDomain(state) {
    state.currentDomain = {
      config: new WhitelabelConfig(),
    };
  },

  setCurrentDomain(state, domainId) {
    let domain = find(state.domains, domain => domain.domain_id === domainId);

    domain.config = new WhitelabelConfig(domain.config);

    state.currentDomain = domain;
  },

  updateCurrentDomain(state, config) {
    state.currentDomain.config = config;
  },

  updateCurrentDomainConfig(state, { property, value }) {
    validator.validate(property, value);

    set(state.currentDomain.config, property, value);
  },

  clearDomainImages(state) {
    state.logoImage = null;
    state.bannerImage = null;
    state.faviconImage = null;
  },

  updateDomainImage(state, { type, file }) {
    state[`${type}Image`] = file;
  },
};